export const GET_PERSON_ID = 'GET_PERSON_ID';
export const SET_PERSON = 'SET_PERSON';
export const CACHE_PERSON = 'CACHE_PERSON';
export const SET_PERSON_BY_ID = 'SET_PERSON_BY_ID';
export const SET_PERSON_BY_EMAIL = 'SET_PERSON_BY_EMAIL';
export const CACHE_PERSON_BY_EMAIL = 'CACHE_PERSON_BY_EMAIL';
export const SET_PERSONS = 'SET_PERSONS';
export const CACHE_PERSONS = 'CACHE_PERSONS';
export const SET_RATING = 'SET_RATING';
